import { apiProvider } from "./config/services";

const actionBtn = document.querySelector('[data-action]');

if (actionBtn) {
    actionBtn.addEventListener('click', (event) => {
        const action = actions[event.target.dataset.action] ?? null;

        if (typeof action === 'function') {
            action(event.target);
        }

    });
}

const actions = {
    referral: async () => {
        await apiProvider.get('/referral/generate');
        location.reload();
    },

};
